import { BaseService } from './BaseService';
import { DeviceSyncStatusOverview } from '../models/device-sync-status';

/**
 * `GET /device/sync-status` - what a farm's phones have registered but not yet managed to send.
 *
 * Hand-written through `BaseService` rather than the generated client because the endpoint is newer than
 * `src/api/HealthSystemApi.ts`; it appears there as `DeviceGetDeviceSyncStatus` after the next deliberate
 * `bun run swagger`, and this can move to `api.device` then. The sibling `DeviceService` is hand-written
 * too, so this is consistent either way.
 */
export class DeviceSyncStatusService extends BaseService {
  url = '/device/sync-status';

  /**
   * `farmId` scopes the answer to a farm other than the token's own business unit, for the admin farms
   * overview; omitted, the API answers for the signed-in one. `pendingOnly` is left off deliberately - the
   * widget wants the whole fleet so it can say "12 devices, none behind" rather than only being able to
   * show a problem list, and `BuildQueryString` drops a `false` anyway.
   */
  getOverview = async (farmId?: string): Promise<DeviceSyncStatusOverview> => {
    const query = this.BuildQueryString({ farmId });
    const result = await this.Fetch(query ? `${this.url}?${query}` : this.url, 'GET');
    return this.FromResult<DeviceSyncStatusOverview>(result);
  };
}

export default DeviceSyncStatusService;
